(function () {

  // STICKY SHADOW
  window.addEventListener("scroll", function () {
    const header = document.getElementById("custom-header");
    if (!header) return;
    header.classList.toggle("scrolled", window.scrollY > 300);
  });

  // SHOP DROPDOWN
  const shop = document.querySelector(".nav-shop");
  const toggle = document.querySelector(".shop-toggle");

  if (shop && toggle) {
    toggle.addEventListener("click", () => {
      shop.classList.toggle("open");
    });

    document.addEventListener("click", (e) => {
      if (!shop.contains(e.target)) {
        shop.classList.remove("open");
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        shop.classList.remove("open");
      }
    });
  }

  // WISHLIST COUNT (SWYM)
  function updateWishlistCount() {
    if (window.SwymWishlistAPI) {
      window.SwymWishlistAPI.getWishlistCount().then(count => {
        const el = document.getElementById("wishlist-count");
        if (el) el.textContent = count;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    const interval = setInterval(() => {
      if (window.SwymWishlistAPI) {
        updateWishlistCount();
        clearInterval(interval);
      }
    }, 300);
  });

  document.addEventListener("swym:updated", function () {
    updateWishlistCount();
  });

})();